import type { HermesGuardFn } from '@/router/guards/types'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

const LAUNCH_ROUTES = new Set([
  'brand.launch',
  'admin.launch',
  'admin.launch.messenger',
  'admin.launch.brand',
  'admin.launch.brand.messenger',
])

export const checkLaunchFeatureFlag: HermesGuardFn = async (to) => {
  if (!LAUNCH_ROUTES.has(to.name as string)) return undefined

  const featureFlags = useFeatureFlags()

  if (!featureFlags.isEnabled('hermes.launchDashboard')) {
    if (to.name === 'brand.launch') {
      // Keep the query so an embedded view (`embed=1`, e.g. Hercules' Launch
      // tool iframe) stays chrome-less after the fallback redirect.
      return {
        name: 'brand.home',
        params: { brandId: to.params.brandId },
        query: to.query,
      }
    }
    return { name: 'brands' }
  }

  if (
    (to.name === 'admin.launch.messenger' ||
      to.name === 'admin.launch.brand.messenger') &&
    !featureFlags.isEnabled('hermes.launchInbox')
  ) {
    if (to.name === 'admin.launch.brand.messenger') {
      return {
        name: 'admin.launch.brand',
        params: { brandId: to.params.brandId },
      }
    }
    return { name: 'admin.launch' }
  }

  return undefined
}
